angular.module('eatself')
.filter('isEmpty', function() {
  return function(obj) {
    return _.isEmpty(obj);
  };
})